import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class BeginAutomaticInvoicingCorrectionError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BeginAutomaticInvoicingCorrectionError', ...args);
    }
}
export default BeginAutomaticInvoicingCorrectionError;
